import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS_V2 } from '../service/ENDPOINTS_V2'
import { Questionnaire } from '../Types'

export type ConfigQuestionniareGroup = {
  questionnaire: Questionnaire
  computedCreatedAt: Date
  protocolTitle: string
  activatedAt: Date
  retiredAt: Date
}

export type SubjectAssignmentsType = {
  dateMap: {
    [date: string]: {
      assignments: any[]
      date: string
    }[]
  }
  config: {
    subjectStatus: string
    endDate: Date
    onboardingDate: string
    dailyQuestionnaires: [ConfigQuestionniareGroup[]]
    siteTime: Date
  }
}
export const useSubjectAssignments = (projectId: string, subjectId: string) => {
  const p = ENDPOINTS_V2.SUBJECTS.getSubjectAssignments(projectId, subjectId)
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  const typedData = data.data as SubjectAssignmentsType

  return {
    data: !data ? data : typedData,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
